import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, CircularProgress, Grid, Link } from '@material-ui/core';
import { LinkOff as LinkOffIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEContainerScroll, FHEItemText, FHETextField, ProductTitle, FHEMiniFormEditButton } from 'data/components';
import { Toastr, Logger, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { updateProductField, dissociateProduct } from '../../../../../../data/Products/actions';

class AirzoneBasicForm extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        identifier: PropTypes.string.isRequired,
        homeId: PropTypes.string.isRequired,
        homeLabel: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        children: PropTypes.object,
        refreshStatusProduct: PropTypes.func.isRequired,
        updateProductField: PropTypes.func.isRequired,
        dissociateProduct: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        children: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: this.getDataForm(),
            deleteLoading: false
        };
    }
    componentDidMount() {
        const { profile, history } = this.props;
        const userRight = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('products_airzone_details');
        if (!userRight) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }
    }

    navigateToHomeDetail = () => {
        const { homeId, history } = this.props;
        return history.push({
            pathname: `/${history.environment}/home/detail/${homeId}`
        });
    };

    getDataForm = () => {
        const { label } = this.props;
        return { label };
    };

    loadInputs = () => {
        this.setState({
            form: this.getDataForm(),
            formDisabled: true,
            textInput_error: {},
            sendLoading: false
        });
    };

    askDissociateProduct = e => {
        const { history } = this.props;
        e.preventDefault();
        this.setState({ deleteLoading: true });
        Toastr.confirm(
            Translator.translate(`generic.products.table.action.dissociate.confirmRemove`),
            Translator.translate(`generic.products.table.action.dissociate.confirmRemoveTitle`),
            {
                onYes: () => {
                    this.dissociateProduct().catch(() => {
                        this.setState({ deleteLoading: false });
                    });
                },
                onNo: () => {
                    this.setState({ deleteLoading: false });
                }
            }
        );
    };
    dissociateProduct = () => {
        const { homeId, type, identifier, dissociateProduct, history } = this.props;

        return dissociateProduct('state', homeId, identifier, type, 'dissociated', type)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.table.action.dissociate.success`));
                return history.goBack();
            })
            .catch(err => {
                Toastr.error(Translator.translate(`generic.products.table.action.dissociate.error`), err);
                throw err;
            });
    };

    refreshStatusProduct = () => {
        const { type, identifier, refreshStatusProduct } = this.props;
        return refreshStatusProduct(type, identifier);
    };

    handleChange = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleClick = () => {
        this.setState({
            formDisabled: false
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;
        this.setState({
            formDisabled: !formDisabled
        });
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = async () => {
        const { form } = this.state;
        const { homeId, identifier, type, updateProductField, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            updateProductField('label', homeId, identifier, type, form.label, type)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editLabelSuccess`, form.label));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate(`generic.products.actions.editLabelError`, form.label));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.products.actions.editLabelError`, form.label)
                        );
                    }
                });
        }
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    validateForm = form => {
        const errors = {};

        if (this.isEmpty(form.label)) {
            errors['label'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    render() {
        const { formDisabled, textInput_error, sendLoading, form, deleteLoading } = this.state;
        const { identifier, homeId, homeLabel, status, state, children, type, profile, classes, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        const userRightDissociate = profile.get('admin') || userRights.includes(`products_${type}_dissociate`);
        const userRightRefreshStatus = profile.get('admin') || userRights.includes(`products_${type}_refreshStatus`);
        const userRightHomeDetails = profile.get('admin') || userRights.includes('homeDetails');
        const userRightUpdate = profile.get('admin') || userRights.includes(`products_${type}_update`);

        return (
            <Fragment>
                <ProductTitle homeLabel={homeLabel} type={type} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.identifier')}
                                    itemContent={identifier ? identifier.match(/.{1,2}/g).join(':') : 'N/A'}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate(`general.showHome`)}
                                    itemTitle={Translator.translate('general.table.column.homeLabel')}
                                    itemContent={
                                        userRightHomeDetails ? (
                                            <Link component="button" onClick={this.navigateToHomeDetail}>
                                                {`#${homeId} ${homeLabel}`}
                                            </Link>
                                        ) : (
                                            `#${homeId} ${homeLabel}`
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEMiniFormEditButton
                                    handleEdit={this.handleEdit}
                                    confirmEdit={this.confirmEdit}
                                    sendLoading={sendLoading}
                                    formDisabled={formDisabled}
                                    hasRightToEdit={userRightUpdate}
                                >
                                    <FHETextField
                                        disabled={formDisabled || !userRightUpdate}
                                        id="label"
                                        value={!form.label || form.label === null ? '' : form.label}
                                        error={textInput_error.label}
                                        helperText={textInput_error.label ? textInput_error.label : null}
                                        label={Translator.translate('general.table.column.label')}
                                        name="label"
                                        onChange={this.handleChange}
                                    />
                                </FHEMiniFormEditButton>
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate(`generic.products.table.action.refresh.tooltip`)}
                                    onClick={userRightRefreshStatus ? this.refreshStatusProduct : null}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${status}`)}
                                    classContent={status === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.status')}
                                    itemContent={Translator.translate(`general.${state}`)}
                                    classContent={state === 'dissociated' ? classes.disconnectedColor : classes.connectedColor}
                                    iconButton={
                                        userRightDissociate &&
                                        (!deleteLoading ? (
                                            <LinkOffIcon onClick={this.askDissociateProduct} />
                                        ) : (
                                            <CircularProgress size={20} color="inherit" />
                                        ))
                                    }
                                    iconButtonTooltip={Translator.translate(`generic.products.table.action.dissociate.tooltip`)}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {children}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const homes = state.environments[history.environment].data.Homes.get('list');
    return {
        profile: state.data.user,
        identifier: product.getIn(['identifier'], ''),
        homeId: product.getIn(['homeId'], '').toString(),
        homeLabel: homes.getIn([product.getIn(['homeId'], '').toString(), 'label'], ''),
        label: product.getIn(['label'], ''),
        status: product.getIn(['status'], ''),
        state: product.getIn(['state'], ''),
        type: product.getIn(['type'], '')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    },
    containerMiniForm: {
        position: 'relative'
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/Airzone/BasicForm/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductField,
                        dissociateProduct
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(AirzoneBasicForm))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Airzone/BasicForm/index.js